<div class="auth-container" style="background: none; height: 100vh; overflow: unset !important;">
    <app-toolbar></app-toolbar>
    <div class="container">

        <div class="frequent-questions-title">
            <span class="title">
                PREGUNTAS FRECUENTES
            </span>
        </div>
        <div class="questions-container" >
            <span class="question">
                ¿Necesitás ayuda?
            </span>
            <span class="text" style="margin-top: 10px;">
                Podés comunicarte vía e-mail a <span class="text" style="color:#FF6600">comercios@fiserv.com</span>
            </span>
            <span class="text" style="margin-top: 10px;">
                ¿Tenes consultas o dudas? Podres ingresar al siguiente link <a style="color:#FF6600"  href="https://fiservapp.com.ar/faqs" target="_blank">https://fiservapp.com.ar/faqs</a>
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Qué es un QR?
            </span>
            <span class="text" style="margin-top: 10px;">
                Un QR es un código de respuesta rápida por sus siglas en inglés (QR “Quick Response”), contiene
                información específica del comercio.
            </span>
            <span class="text">
                Los datos dentro del código QR son definidos siguiendo el estándar de mercado.
            </span>
            <span class="text">
                Es la forma más simple, rápida y segura para recibir pagos desde cualquier billetera.
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Qué tipo de medios de pago puede aceptar QR?
            </span>
            <span class="text" style="margin-top: 10px;">
                Aceptamos pagos con transferencias, dinero en cuenta bancaria o virtual.
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Cuáles son las billeteras habilitadas para QR Estático?
            </span>
            <div class="container-images">
                <img class="image"  src="assets/images/logos/byn/bna+_negro.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/cuenta_dni.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/hooli_negro.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/klio_negro.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/modo.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/moni.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/naranjax_negro.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/nvio_negro.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/personalpay.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/pluspagos_santafe.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/propago.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/resimple.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/telepagos.png" alt=""/>
                <img class="image"  src="assets/images/logos/byn/uala.png" alt=""/>

            </div>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Cuáles son los requisitos para poder operar con QR Estático?
            </span>
            <span class="text" style="margin-top: 10px;">
                Tener N° Cuit.
            </span>
            <span class="text">
                Ser Monotributista, Autónomo o Persona jurídica.
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿En cuánto tiempo puedo tener mi QR Estático habilitado?
            </span>
            <span class="text" style="margin-top: 10px;">
                Para monotributista y autónomos , la obtención del QR es en el momento.
            </span>
            <span class="text">
                Sólo es necesario realizar el proceso de alta en la web, la validación de identidad con el celular y
                ¡listo!
            </span>
            <span class="text">
                Para Personas Jurídicas, el alta requiere verificación de la documentación, puede demorar hasta 72
                horas.
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Cómo hago para realizar el alta del QR Estático?
            </span>
            <div class="textEnum">
                <span class="text">
                    <u>Alta para Personas Físicas:</u>
                </span>
                <span class="text spanContainer">
                    <span class="text">
                        1. Ingresar a la web <a style="color: #FF6600;" href="qr.Fiservapp.com.ar">
                            qr.Fiservapp.com.ar</a>
                    </span>
                    <span class="text">
                        2. Indicar su N° de Cuit el cual se validará con Afip.
                    </span>
                    <span class="text">
                        3. Ingresar los datos personales para asociarlos al comercio
                    </span>
                    <span class="text">
                        4. Se genera un QR el cual debe ser escaneado por su celular para que se realice el proceso de
                        validación de identidad en el momento.
                    </span>
                    <span class="text">
                        5. Una vez que se valida la identidad, automaticamente se muestra la pantalla de inicio del
                        portal web donde tiene sus datos personales cargados dentro de “Mi Perfil”
                    </span>
                    <span class="text">
                        6. Tanto en la app del celular como en el portal se muestra un cuadrito para imprimir el QR
                    </span>
                    <span class="text">
                        7. Se imprime, se expone en el comercio y ¡listo!
                    </span>
                </span>
            </div>
            <div class="textEnum" style="margin-top:30px">
                <span class="text">
                    <u>Alta para Personas Jurídicas:</u>
                </span>
                <span class="text spanContainer">
                    <span class="text">
                        1. Ingresar a la web <a style="color: #FF6600;" href="qr.Fiservapp.com.ar">
                            qr.Fiservapp.com.ar</a>
                    </span>
                    <span class="text">
                        2. Indicar su N° de Cuit el cual se validará con Afip.
                    </span>
                    <span class="text">
                        3. Se registra al comercio y para eso se ingresan los datos del responsable de la cuenta del
                        comercio.
                    </span>
                    <span class="text">
                        4. Se visualiza un QR donde la persona tiene que escanearlo para comenzar con el proceso de
                        validacion de identidad desde su celular.
                    </span>
                    <span class="text">
                        5. Se solicita al respondable que ingrese el mail y genere una contraseña para crear los datos
                        de acceso al portal.
                    </span>
                    <span class="text">
                        6. Se registra al comercio y se ingresan los datos del negocio
                    </span>
                    <span class="text">
                        7. Se ingresa el N° de CBU o Alias asociado al Cuit que estan registrando para validar la
                        identidad y como respaldo de la cuenta.
                    </span>
                    <span class="text">
                        8. Se solicita adjuntar determinada documentacion para poder generar el alta al comercio
                    </span>
                    <span class="text">
                        9. Un oficial de Back Office debe verificar toda la información que adjuntó el comercio y de
                        acuerdo a eso confirman o no la cuenta.
                    </span>
                    <span class="text">
                        10. Una vez que se valida la documentación, le llega un mail para ingresar a la web y poder
                        imprimir su QR.
                    </span>
                    <span class="text">
                        11. Tanto en la app del celular como en el portal se muestra un cuadrito para imprimir el QR
                    </span>
                    <span class="text">
                        11. Tanto en la app del celular como en el portal se muestra un cuadrito para imprimir el QR
                    </span>
                    <span class="text">
                        12. Se imprime, se expone en el comercio y ¡listo!
                    </span>

                </span>
            </div>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Qué documentación necesito presentar si soy persona jurídica?
            </span>
            <span class="text spanContainer">
                <ul>
                    <li>Formulario de identificación de cliente (se adjunta en la web).
                    </li>
                    <li>DDJJ Grupo, vinculadas, accionistas y beneficiarios (se adjunta en la web).</li>
                    <li>DDJJ Sujetos obligados.</li>
                    <li>Copia del Contrato social/Estatuto social vigente y sus reformas (de corresponder).</li>
                    <li>Actas de Asamblea de socios / directorio en el que se designan a las autoridades vigentes.</li>
                    <li>Poder/es que justifican las facultades de los apoderados que operarán en representación del
                        cliente vigente.
                    </li>
                    <li>Estados Contables (EECC) del último ejercicio cerrado certificado por contador público (se
                        acepta copia en PDF donde se visualice la oblea del contador público nacional). </li>
                </ul>
            </span>

        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Cómo cobrar con QR?
            </span>
            <span class="text" style="margin-top: 8px;">
                Cobrar con QR Estático es muy simple:
            </span>
            <div class="textEnum">

                <span class="text spanContainer">
                    <span class="text">
                        1. El cliente escanea el QR impreso.
                    </span>
                    <span class="text">
                        2. Ingresa el monto a pagar en su billetera.
                    </span>
                    <span class="text">
                        3. Elige el medio de pago y confirma la compra.
                    </span>
                    <span class="text">
                        4. En la web se corrobora la confirmación del pago.
                    </span>
                    <span class="text">
                        5. ¡Listo! El dinero se encuentra disponible en el momento.
                    </span>
                </span>
            </div>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Cómo cobrar con QR ingresando importe?
            </span>
            <span class="text" style="margin-top: 10px;">
                Hay una opción donde el comercio puede ingresar el monto previamente a que el cliente escanee el
                QR.
            </span>
            <span class="text">
                Tiene que ingresar a la WEB <a style="color: #FF6600;" href="qr.Fiservapp.com.ar">
                    qr.Fiservapp.com.ar</a> - solapa COBRAR - ORDEN DE PAGO y ahí cargar los datos solicitados.
            </span>
            <span class="text">
                Cuando se confirme la orden de pago avisar al cliente que lea el QR y ya no será necesario que
                ingrese el monto.
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Cuál es el costo por cobrar con el QR Estático? 
            </span>
            <span class="text" style="margin-top: 10px;">
                El arancel que se cobra es del 0,8% + IVA el cual se descontará directamente del neto a acreditarse
                en la cuenta bancaria. La acreditación es en el momento. 
            </span>
            <span class="text">
                Por los primeros 3 meses, o hasta alcanzar 1000 UVAS, vas a tener un arancel gratuito (0% de costo), en
                concepto del Tramo Gratuito según la regulación del BCRA. Una vez finalizados, por cada pago recibido, el
                arancel será de 0,8%.
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Cuándo corresponde el cobro de retenciones?
            </span>
            <span class="text" style="margin-top: 10px;">
                Según la condición fiscal del comercio tiene retenciones aplicables de IVA, Ganancias e IIBB.
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Cuándo se me debitan las retenciones cobradas?
            </span>
            <span class="text" style="margin-top: 10px;">
                Las retenciones y/o percepciones se debitarán en el momento de la venta, junto con el arancel del 0,8% + IVA.
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Dónde visualizo el cobro de mis retenciones?
            </span>
            <span class="text" style="margin-top: 10px;">
                Las retenciones se envían al mail registrado por el comercio cada 15 días y las facturas cada 12 días. 
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Dónde visualizo el cobro de mis retenciones?
            </span>
            <span class="text" style="margin-top: 10px;">
                Si, ingresando en la web <a style="color: #FF6600;" href="qr.Fiservapp.com.ar">
                    qr.Fiservapp.com.ar</a> en la sección Movimientos se pueden ver las
                operaciones confirmadas, acreditadas y rechazadas. 
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                ¿Cuáles son los estados de las operaciones?
            </span>
            <span class="text spanContainer">
                <ul>
                    <li><u style="font-weight: bold;">Confirmado:</u> Confirmación del débito en la billetera
                    </li>
                    <li><u style="font-weight: bold;">Acreditado:</u> Confirmación de la recepción del pago.
                    </li>
                    <li><u style="font-weight: bold;">Rechazado:</u> Rechazo de la operación.
                    </li>
                </ul>
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿A qué cuenta me ingresa el dinero de mis ventas?
            </span>
            <span class="text" style="margin-top: 10px;">
                El dinero ingresa en la cuenta virtual creada para poder operar con QR. 
            </span>
            <span class="text">
                Podes transferir el dinero a otras cuentas propias o de terceros bancarias o virtuales. 
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Dónde puedo ubicar mi QR? 
            </span>
            <span class="text" style="margin-top: 10px;">
                El QR debe estar expuesto de manera visible para que el cliente pueda leerlo sin tener que
                solicitarlo. Para que el proceso de venta sea fácil, rápido y seguro. 
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Se puede anular un pago?
            </span>
            <span class="text" style="margin-top: 10px;">
                No, sólo es posible realizar una devolución.  
            </span>
        </div>
        <div class="questions-container">
            <span class="question">
                ¿Cómo puedo realizar una devolución?
            </span>
            <span class="text" style="margin-top: 10px;">
                Ingresar a la Web <a style="color: #FF6600;" href="qr.Fiservapp.com.ar">
                    qr.Fiservapp.com.ar</a> dentro de la solapa Movimientos ir a la operación que se
                quiere reintegrar, seleccionar el botón devolución y seguir los pasos que se indican.
            </span>
        </div>
        <div class="questions-container" style="padding-top: 30px !important;">
            <span class="question">
                El cliente no puede leer el QR ¿Qué hago?
            </span>
            <span class="text" style="margin-top: 8px;">
                Si tu cliente tiene problemas para leer el QR, debería verificar lo siguiente:
            </span>
            <div class="textEnum">

                <span class="text spanContainer">
                    <span class="text">
                        1. Verificar la conexión a Internet
                    </span>
                    <span class="text">
                        2. Verificar que ningún obstáculo se interponga entre la lente de la cámara y el código QR.
                    </span>
                    <span class="text">
                        3. Puede ocurrir que el código QR se encuentre desgastado, en ese caso debería realizar una
                        nueva impresión del QR para que el mismo pueda leerse correctamente. 
                    </span>
                </span>
            </div>
        </div>
    </div>
    <app-new-footer></app-new-footer>
</div>